import { useSelector } from 'react-redux';

import { EThemeKey } from '@lumahealthhq/ui-common';
import { ThemeOptions } from '@lumahealthhq/ui-core';
import { LinkProps } from '@mui/material';

import { ECustomWebStylesScope, makeSelectCustomWebStyle } from '@lib/selectors';
import storageService from '@lib/services/storageService';

interface IStylesPatientAppRedesign {
  styles: {
    theme: Partial<ThemeOptions> & {
      key?: EThemeKey;
      // header
      includeLanguageSelector?: boolean;
      includeMenuWithLinks: {
        enabled?: boolean;
        links?: LinkProps[];
      };
      // patient forms
      homePage?: string;
      includePatientFormFooter: {
        enabled?: boolean;
        logoUrl?: string;
        links?: LinkProps[];
        bottomLine?: string;
      };
    };
  };
}

export default function useStylesPatientAppRedesign() {
  const id = storageService.getParameters().customWebStylesId;
  const styles = useSelector(
    makeSelectCustomWebStyle({
      id,
      scope: ECustomWebStylesScope.PatientFormsV3,
      onlyPublished: !id,
    }),
  );

  return styles as IStylesPatientAppRedesign | undefined;
}
